<template>
  <div class="reset-grid">
    <Dialog width="580px" :canCloseWithEsc="true" :showCloseIcon="true">
      <template slot="title">
        <div class="title">
          {{ modalResetGrid.title }}
        </div>
      </template>
      <template slot="body">
        <div class="description" v-html="modalResetGrid.data"></div>
      </template>
      <template slot="actions">
        <div class="d-flex justify-end w-100" style="column-gap: 20px; padding: 12px 20px 28px">
          <Button
              dark
              color="#F16063"
              @click="confirmResetGrid"
            >
              <span>Reset Grid</span>
            </Button>
          <Button
              dark
              outlined
              color="grey"
              @click="close"
            >
              <span style="color: #1A202C">Cancel</span>
            </Button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Dialog from '@/components/layouts/dialog'
import Button from '@/components/elements/Button'
import { trackEvent } from '@/utils/analytics'

export default {
  name: 'modal-reset-grid',
  components: { Dialog, Button },
  props: {
    onRecalcResults: Function,
    visitStatus: String
  },
  methods: {
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    close () {
      this.TOGGLE_DIALOG({ name: 'modalResetGrid', isOpen: false, root: true })
    },
    confirmResetGrid() {
      trackEvent(this, 'reset_grid', 'Evaluation', 'Grid Was Successfully Reset')

      this.close()
      if (this.onRecalcResults) {
        this.onRecalcResults(this.visitStatus)
      }
    }
  },
  computed: {
    ...mapState({
      modalResetGrid: state => state.dialogs.modalResetGrid
    }),
    dialogs () {
      return this.$store.state.dialogs
    }
  }
}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}

.reset-grid {
  ::v-deep .v-btn {
    border-radius: 16px;
    height: 56px;
    font-size: 14px;
    letter-spacing: 0;
    padding: 0 24px;
  }
  ::v-deep .v-dialog__container {
    .v-card {
      &__title {
        padding: 36px 36px 33px !important;
        position: relative;
        .image {
          text-align: center;
          cursor: pointer;
        }
        .title {
          font-family: 'Poppins';
          font-weight: 600;
          font-size: 28px !important;
          color: #27272E;
          letter-spacing: 0 !important;
        }
        .v-icon {
          display: none;
          position: absolute;
          right: 15px;
          top: 25px;
        }
      }
      &__text {
        .description {
          font-family: 'Poppins';
          padding: 0 36px 63px 36px;
          font-weight: 400;
          font-size: 18px;
          line-height: 1.66;
          color: #1A202C;
          letter-spacing: 0;
          p {
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
